import { useEffect, useState } from "react";
import api from "@/lib/api";
import { LayoutDashboard, BarChart3, Package, Building2, ShoppingBag, Users, MessageSquareHeart, FileSearch, Cake, Sparkles, DollarSign, Ban, Warehouse, UserPlus, Truck, Images, Ticket, Crown } from "lucide-react";

import AdminOverviewTab from "@/pages/admin/AdminOverviewTab";
import AnalyticsTab from "@/pages/AdminAnalytics";
import AdminDropsTab from "@/pages/AdminDropsTab";
import AdminFarmsTab from "@/pages/AdminFarmsTab";
import AdminOrdersTab from "@/pages/admin/AdminOrdersTab";
import AdminUsersTab from "@/pages/admin/AdminUsersTab";
import AdminSupportTab from "@/pages/admin/AdminSupportTab";
import AdminApplicationsTab from "@/pages/admin/AdminApplicationsTab";
import AdminBirthdayRewardsTab from "@/pages/admin/AdminBirthdayRewardsTab";
import AdminBrandApplicationsTab from "@/pages/admin/AdminBrandApplicationsTab";
import AdminAmbassadorPayoutsTab from "@/pages/admin/AdminAmbassadorPayoutsTab";
import AdminFounding1Tab from "@/pages/admin/AdminFounding1Tab";
import AdminCancellationsTab from "@/pages/admin/AdminCancellationsTab";
import AdminMembershipCancellationsTab from "@/pages/admin/AdminMembershipCancellationsTab";
import AdminWarehousesTab from "@/pages/admin/AdminWarehousesTab";
import AdminWaitlistTab from "@/pages/admin/AdminWaitlistTab";
import AdminShipmentsTab from "@/pages/admin/AdminShipmentsTab";
import AdminMarketplaceTab from "@/pages/admin/AdminMarketplaceTab";
import AdminImageLibraryTab from "@/pages/admin/AdminImageLibraryTab";
import AdminPromosTab from "@/pages/admin/AdminPromosTab";
import AdminMembersTab from "@/pages/admin/AdminMembersTab";

const TABS = [
  { id: "overview", label: "Overview", icon: LayoutDashboard },
  { id: "members", label: "Members", icon: Crown },
  { id: "analytics", label: "Analytics", icon: BarChart3 },
  { id: "marketplace", label: "Marketplace", icon: ShoppingBag },
  { id: "promos", label: "Promo codes", icon: Ticket },
  { id: "drops", label: "Drops", icon: Package },
  { id: "farms", label: "Farms", icon: Building2 },
  { id: "images", label: "Image library", icon: Images },
  { id: "warehouses", label: "Warehouses", icon: Warehouse },
  { id: "applications", label: "Farm apps", icon: FileSearch },
  { id: "brand-apps", label: "Brand apps", icon: Sparkles },
  { id: "payouts", label: "Payouts", icon: DollarSign },
  { id: "founding1", label: "Founding", icon: Sparkles },
  { id: "waitlist", label: "Waitlist", icon: UserPlus },
  { id: "orders", label: "Orders", icon: ShoppingBag },
  { id: "shipments", label: "Shipments", icon: Truck },
  { id: "cancellations", label: "Order cancels", icon: Ban },
  { id: "membership-cancels", label: "Membership cancels", icon: Ban },
  { id: "users", label: "Users", icon: Users },
  { id: "rewards", label: "Rewards", icon: Cake },
  { id: "support", label: "Support", icon: MessageSquareHeart },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [tab, setTab] = useState("overview");

  useEffect(() => {
    api.get("/admin/dashboard").then(r => setStats(r.data)).catch(()=>{});
  }, []);

  if (!stats) return <div className="p-10" data-testid="admin-loading">Loading…</div>;

  return (
    <div className="max-w-7xl mx-auto px-6 py-12" data-testid="admin-dashboard">
      <p className="overline">Platform admin</p>
      <h1 className="font-display text-5xl mt-3">Control room.</h1>

      <div className="mt-8 flex items-center justify-between gap-3 flex-wrap">
        <p className="text-sm text-[var(--ff-text-muted)]">Deep operations tools live in dedicated screens.</p>
        <a
          href="/warehouse"
          className="inline-flex items-center gap-1.5 rounded-full border border-[var(--ff-primary)] text-[var(--ff-primary)] hover:bg-[var(--ff-primary)] hover:text-white transition-colors px-4 py-1.5 text-xs font-semibold"
          data-testid="admin-warehouse-link"
        >
          Open warehouse →
        </a>
      </div>

      <div className="mt-4 border-b border-[var(--ff-border)] overflow-x-auto" data-testid="admin-tabs">
        <div className="flex gap-1 min-w-max">
          {TABS.map(t => {
            const Icon = t.icon;
            const active = tab === t.id;
            return (
              <button key={t.id} onClick={() => setTab(t.id)} data-testid={`atab-${t.id}`}
                className={`flex items-center gap-2 px-5 py-3 text-sm font-medium border-b-2 transition-all whitespace-nowrap ${active ? "border-[var(--ff-primary)] text-[var(--ff-primary)]" : "border-transparent text-[var(--ff-text-secondary)] hover:text-[var(--ff-primary)]"}`}>
                <Icon size={16}/> {t.label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-10">
        {tab === "overview" && <AdminOverviewTab stats={stats}/>}
        {tab === "members" && <AdminMembersTab />}
        {tab === "analytics" && <AnalyticsTab />}
        {tab === "marketplace" && <AdminMarketplaceTab />}
        {tab === "promos" && <AdminPromosTab />}
        {tab === "drops" && <AdminDropsTab />}
        {tab === "farms" && <AdminFarmsTab />}
        {tab === "images" && <AdminImageLibraryTab />}
        {tab === "warehouses" && <AdminWarehousesTab />}
        {tab === "applications" && <AdminApplicationsTab />}
        {tab === "brand-apps" && <AdminBrandApplicationsTab />}
        {tab === "payouts" && <AdminAmbassadorPayoutsTab />}
        {tab === "founding1" && <AdminFounding1Tab />}
        {tab === "waitlist" && <AdminWaitlistTab />}
        {tab === "orders" && <AdminOrdersTab />}
        {tab === "shipments" && <AdminShipmentsTab />}
        {tab === "cancellations" && <AdminCancellationsTab />}
        {tab === "membership-cancels" && <AdminMembershipCancellationsTab />}
        {tab === "users" && <AdminUsersTab />}
        {tab === "rewards" && <AdminBirthdayRewardsTab />}
        {tab === "support" && <AdminSupportTab />}
      </div>
    </div>
  );
}
